import { useZocksQuota } from '../../../components/ScopedBlock/hooks'

export const SCHEDULING_ENABLED_QUOTA = 'scheduling.enabled.value'
export const SCHEDULING_TEMPLATES_QUOTA = 'scheduling.templates.value'

export const useSchedulingTemplatesEnabled = () => {
  const { hasQuota, quotaSuccess, isFetching } = useZocksQuota()

  return {
    isEnabled: hasQuota(SCHEDULING_ENABLED_QUOTA) && hasQuota(SCHEDULING_TEMPLATES_QUOTA),
    isLoading: !quotaSuccess && isFetching,
  }
}
